var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"mx-auto my-2 lighten-4",attrs:{"max-width":"800","tile":""}},[_c('v-card-title',[_vm._v("Authentication error")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }